import { Ranking } from "@wl/types/lib/types/ranking/ranking";

/**
 * Ranking state.
 *
 * @export
 * @interface TabState
 */
export interface RankingState {
    /**
     * Global ranking.
     *
     * @type {Ranking[]}
     * @memberof RankingState
     */
    global: Ranking[];

    /**
     * Local ranking.
     *
     * @type {Ranking[]}
     * @memberof RankingState
     */
    local: Ranking[];
}

/**
 * Initial Ranking module state.
 *
 * @return {(() => TabState)}
 */
const state = (): RankingState => ({
    global: [],
    local: [],
});

export default state;
